import { Icon, type TIconProps } from '~/components/icon'
import { type ScopedProps, useListItemContext } from '../../list-item'

type ListItemIconProps = TIconProps & {}

export const ListItemIcon = (props: ListItemIconProps) => {
  const { symbol, __scopeListItem, testID } =
    props as ScopedProps<ListItemIconProps>

  const { disabled } = useListItemContext('ListItemIcon', __scopeListItem)

  return (
    <Icon
      symbol={symbol}
      size="extra-small"
      color={disabled ? 'colorTextNeutralDisabled' : 'colorTextNeutralDefault'}
      testID={testID}
    />
  )
}
